module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA16.db87706b.jpg";